/**
 * Rounds a number to the specified precision.
 * By default rounds to whole numbers.
 *
 * @example
 * round(13.5472)     = 14
 * round(13.5472, 0)  = 14
 * round(13.5472, 1)  = 13.5
 * round(13.5472, 2)  = 13.55
 * round(13.5472, 3)  = 13.547
 * round(13.5472, -1) = 10
 * round(13.5472, -2) = 0
 * round(149, -2)     = 100
 * round(150, -2)     = 200
 * @param value - The number to round
 * @param precision - The number of decimal points to round the number to
 * @returns The rounded number
 */
export function round(value: number, precision = 0): number {
    const factor = 10 ** precision;
    const tempNumber = value * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
}
